module.exports = __webpack_public_path__ + "img/image-edit-close-icon.8fe34f7a.svg";